import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../DataTable/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../data/Constants';
import { getInternalProductCatalog } from '../../store/states/DataMaintenanceSlice';
import { useApiError } from '../../hooks';

import type { IManagementProps } from '../../../types';

export const InternalProductCatalog = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.ProductCatalogKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.internalProductCatalog')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.InternalProductCatalog}
        getDataList={getInternalProductCatalog}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
